import { Link } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useLocalePath } from '../../hooks/useLocalePath'
import styles from './Footer.module.css'

export default function Footer() {
  const { t } = useTranslation('common')
  const lp = useLocalePath()
  const currentYear = new Date().getFullYear()

  return (
    <footer className={styles.footer}>
      <div className={styles.container}>
        <div className={styles.grid}>
          <div className={styles.brand}>
            <Link to={lp('/')} className={styles.logo}>
              <svg viewBox="0 0 44 44" width="26" height="26" fill="none">
                <circle cx="31.8" cy="8.1" r="2" fill="#0D9488"/>
                <circle cx="27.6" cy="6.0" r="2" fill="#1A9280"/>
                <circle cx="23.1" cy="5.0" r="2" fill="#279078"/>
                <circle cx="18.5" cy="5.4" r="2" fill="#338F70"/>
                <circle cx="14.2" cy="6.9" r="2" fill="#408D68"/>
                <circle cx="10.4" cy="9.6" r="2" fill="#4D8B5F"/>
                <circle cx="7.5" cy="13.2" r="2" fill="#5A8957"/>
                <circle cx="5.6" cy="17.4" r="2" fill="#66874F"/>
                <circle cx="5.0" cy="22.0" r="2" fill="#738547"/>
                <circle cx="5.6" cy="26.6" r="2" fill="#80843F"/>
                <circle cx="7.5" cy="30.8" r="2" fill="#8D8237"/>
                <circle cx="10.4" cy="34.4" r="2" fill="#99802F"/>
                <circle cx="14.2" cy="37.1" r="2" fill="#A67E27"/>
                <circle cx="18.5" cy="38.6" r="2" fill="#B37C1E"/>
                <circle cx="23.1" cy="39.0" r="2" fill="#C07B16"/>
                <circle cx="27.6" cy="38.0" r="2" fill="#CC790E"/>
                <circle cx="31.8" cy="35.9" r="2" fill="#D97706"/>
              </svg>
              <span className={styles.logoText}>CARBON<span className={styles.logoAccent}>13</span></span>
            </Link>
            <p className={styles.tagline}>
              {t('footer.tagline')}
            </p>
          </div>

          <div className={styles.linkGroup}>
            <h4>{t('footer.services')}</h4>
            <Link to={lp('/services/feasibility-studies')}>{t('footer.feasibility')}</Link>
            <Link to={lp('/services/project-design')}>{t('footer.projectDesign')}</Link>
            <Link to={lp('/services/monitoring-verification')}>{t('footer.monitoring')}</Link>
            <Link to={lp('/services/carbon-credit-trading')}>{t('footer.trading')}</Link>
          </div>

          <div className={styles.linkGroup}>
            <h4>{t('footer.projectsTitle')}</h4>
            <Link to={lp('/projects')}>{t('footer.biochar')}</Link>
            <Link to={lp('/projects')}>{t('footer.blueCarbon')}</Link>
            <Link to={lp('/projects')}>{t('footer.afforestation')}</Link>
            <Link to={lp('/projects')}>{t('footer.portfolio')}</Link>
          </div>

          <div className={styles.linkGroup}>
            <h4>{t('footer.company')}</h4>
            <Link to={lp('/about')}>{t('footer.aboutUs')}</Link>
            <Link to={lp('/contact')}>{t('nav.contact')}</Link>
            <Link to={lp('/pricing')}>{t('nav.pricing')}</Link>
          </div>

          <div className={styles.linkGroup}>
            <h4>{t('footer.legalSection')}</h4>
            <a href="#">{t('footer.privacyPolicy')}</a>
            <a href="#">{t('footer.termsOfService')}</a>
          </div>
        </div>

        <div className={styles.bottom}>
          <p>{t('footer.copyright', { year: currentYear })}</p>
          <div className={styles.security}>
            <span className={styles.securityBadge}>
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"/>
              </svg>
              {t('footer.dataEncrypted')}
            </span>
          </div>
        </div>
      </div>
    </footer>
  )
}
